import { CurrencyPipe, DatePipe } from '@angular/common';
import { Component, computed, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { IReporteVentaDetalleRes } from '@core/interfaces/request-response/venta.dto.interface';
import { VentaApiService } from '@core/services/api/venta-api.service';
import { ToastService } from '@shared/services/toast.service';
import { redondearDosDecimales } from '@shared/utils/functions.utils';

@Component({
  selector: 'app-ver-venta',
  imports: [DatePipe, CurrencyPipe],
  templateUrl: './ver-venta.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './ver-venta.css',
})
export class VerVenta {
  private toastService = inject(ToastService);
  private ventaApiService = inject(VentaApiService);
  data = signal<IReporteVentaDetalleRes | null>(null);

  /**
   * El backend devuelve `total` ya neto del descuento global y no expone
   * `subtotal`. Para que el comprobante cuadre, el bruto se reconstruye
   * sumando el descuento al total.
   */
  subtotal = computed(() => {
    const venta = this.data();
    if (!venta) return 0;
    return redondearDosDecimales(Number(venta.total) + Number(venta.descuento));
  });

  mostrarDetalles(venta_id: number) {
    this.data.set(null);
    this.ventaApiService.cargarVenta(venta_id).subscribe({
      next: (res) => {
        this.data.set(res);
      },
      error: (err) => {
        console.error('Error al cargar la venta:', err);
        if (err.status == 401) return;
        this.toastService.show(
          'top-right',
          'error',
          'Error',
          err.error.message || 'No se pudo cargar la venta.',
        );
        return;
      },
    });
  }
}
